import React, { FC } from 'react';

import { InnerLayout } from 'pages';

const ClaimWristbandLayout: FC = () => <InnerLayout />;

export default ClaimWristbandLayout;
